import { useEffect, useState } from "react";
import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { getPageForPath } from "./pages";

function App() {
  const [pathname, setPathname] = useState(() => window.location.pathname);

  useEffect(() => {
    const onPopState = () => setPathname(window.location.pathname);
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  const Page = getPageForPath(pathname);

  return (
    <div>
      <Header pathname={pathname} />
      <main style={{ padding: "32px 20px", maxWidth: 1400, margin: "0 auto" }}>
        <Page />
      </main>
      <Footer />
    </div>
  );
}

export default App;
